import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoggedInGuard } from './guards/logged-in.guard';

const routes: Routes = [
    { 
        path: "",
        redirectTo: "/secure/sell",
        pathMatch: "full"
    },
    {
        path: "connect-account",
        loadChildren: () => import('./pages/connect-account/connect-account.module').then( m => m.ConnectAccountPageModule),
    },
    {
        path: "oauth-callback",
        loadChildren: () => import('./pages/oauth-callback/oauth-callback.module').then( m => m.OauthCallbackPageModule),
    },
    {
        path: 'switch-account',
        loadChildren: () => import('./pages/switch-account/switch-account.module').then( m => m.SwitchAccountPageModule),
    },
    { 
        path: "disconnect-account",
        loadChildren: () => import('./pages/disconnect-account/disconnect-account.module').then( m => m.DisconnectAccountPageModule),
    },
    { 
        path: "reset",
        loadChildren: () => import('./pages/reset/reset.module').then( m => m.ResetPageModule),
    },


    {
        path: "secure",
        children: [
            {
                path: "",
                redirectTo: "/secure/sell",
                pathMatch: "full",
            },
            {
                path: "sell",
                loadChildren: () => import('./pages/secure/sell/sell.module').then( m => m.SellPageModule),
                canActivate: [LoggedInGuard],
            },
            {
                path: "checkout",
                loadChildren: () => import('./pages/secure/checkout/checkout.module').then( m => m.CheckoutPageModule),
                canActivate: [LoggedInGuard],
            },
            {
                path: "settings",
                loadChildren: () => import('./pages/secure/settings/settings.module').then( m => m.SettingsPageModule),
                canActivate: [LoggedInGuard],
            },
            {
                path: "reports",
                children:[
                    {
                        path: "",
                        loadChildren: () => import('./pages/secure/reports/reports.module').then( m => m.ReportsPageModule),
                        canActivate: [LoggedInGuard],
                    },
                    {
                        path: "payments-and-refunds",
                        loadChildren: () => import('./pages/secure/reports/payments-and-refunds/payments-and-refunds.module').then( m => m.PaymentsAndRefundsPageModule),
                        canActivate: [LoggedInGuard],
                    }
                ]
            },
            {
                path: "order-confirmation",
                loadChildren: () => import('./pages/secure/order-confirmation/order-confirmation.module').then( m => m.OrderConfirmationPageModule),
                canActivate: [LoggedInGuard],
            },
            {
                path: "order-pending",
                loadChildren: () => import('./pages/secure/order-pending/order-pending.module').then( m => m.OrderPendingPageModule),
                canActivate: [LoggedInGuard],
            },
            {
                path: "cash-tracking",
                loadChildren: () => import('./pages/secure/cash-tracking/cash-tracking.module').then( m => m.CashTrackingPageModule),
                canActivate: [LoggedInGuard],
            },
            {
                path: "orders",
                loadChildren: () => import('./pages/secure/orders/orders.module').then( m => m.OrdersPageModule),
                canActivate: [LoggedInGuard],
            },
            {
                path: "orders/:id",
                loadChildren: () => import('./pages/secure/orders/order/order.module').then( m => m.OrderPageModule),
                canActivate: [LoggedInGuard],
            },
            {
				path: "orders/:order_id/fulfillment/:fulfillment_id",
				loadChildren: () => import('./pages/secure/orders/order/fulfillment/fulfillment.module').then(m => m.FulfillmentPageModule),
				canActivate: [LoggedInGuard],
			},
            {
				path: "orders/:order_id/refund/:refund_id",
				loadChildren: () => import('./pages/secure/orders/order/refund/refund.module').then(m => m.RefundPageModule),
				canActivate: [LoggedInGuard],
			},
            {
				path: "orders/:order_id/refund/:refund_id/payment/:payment_id",
				loadChildren: () => import('./pages/secure/orders/order/refund/payment/payment.module').then(m => m.PaymentPageModule),
				canActivate: [LoggedInGuard],
			},
            {
				path: "orders/:order_id/return/:return_id",
				loadChildren: () => import('./pages/secure/orders/order/return/return.module').then(m => m.ReturnPageModule),
				canActivate: [LoggedInGuard],
			},
            {
				path: "orders/:order_id/payment/:payment_id",
				loadChildren: () => import('./pages/secure/orders/order/payment/payment.module').then(m => m.PaymentPageModule),
				canActivate: [LoggedInGuard],
			}, 
            {
                path: "organisations",
                loadChildren: () => import('./pages/secure/organisations/organisations.module').then( m => m.OrganisationsPageModule),
                canActivate: [LoggedInGuard],
            },
            {
                path: "organisations/:id",
                loadChildren: () => import('./pages/secure/organisations/organisation/organisation.module').then( m => m.OrganisationPageModule),
                canActivate: [LoggedInGuard],
            },
            {
				path: "organisations/:organisation_id/people",
                loadChildren: () => import('./pages/secure/people/people.module').then( m => m.PeoplePageModule),
				canActivate: [LoggedInGuard],
			},
            {
				path: "organisations/:organisation_id/orders",
                loadChildren: () => import('./pages/secure/orders/orders.module').then( m => m.OrdersPageModule),
				canActivate: [LoggedInGuard],
			},
            {
            	path: "organisations/:organisation_id/shipping-addresses",
                loadChildren: () => import('./pages/secure/organisations/organisation/shipping-addresses/shipping-addresses.module').then( m => m.ShippingAddressesPageModule),
            	canActivate: [LoggedInGuard],
            },
            {
            	path: "organisations/:organisation_id/shipping-addresses/:shipping_address_id",
                loadChildren: () => import('./pages/secure/organisations/organisation/shipping-addresses/shipping-address/shipping-address.module').then( m => m.ShippingAddressPageModule),
            	canActivate: [LoggedInGuard],
            },
            {
                path: "people",
                loadChildren: () => import('./pages/secure/people/people.module').then( m => m.PeoplePageModule),
                canActivate: [LoggedInGuard],
            },
            {
            	path: "people/:id",
                loadChildren: () => import('./pages/secure/people/person/person.module').then( m => m.PersonPageModule),
            	canActivate: [LoggedInGuard],
            },
            {
            	path: "people/:person_id/orders",
                loadChildren: () => import('./pages/secure/orders/orders.module').then( m => m.OrdersPageModule),
            	canActivate: [LoggedInGuard],
            },
            {
            	path: "people/:person_id/shipping-addresses",
                loadChildren: () => import('./pages/secure/people/person/shipping-addresses/shipping-addresses.module').then( m => m.ShippingAddressesPageModule),
            	canActivate: [LoggedInGuard],
            },
            {
            	path: "people/:person_id/shipping-addresses/:shipping_address_id",
                loadChildren: () => import('./pages/secure/people/person/shipping-addresses/shipping-address/shipping-address.module').then( m => m.ShippingAddressPageModule),
            	canActivate: [LoggedInGuard],
            },
            {
            	path: "people/:id/organisations",
                loadChildren: () => import('./pages/secure/organisations/organisation/organisation.module').then( m => m.OrganisationPageModule),
            	canActivate: [LoggedInGuard],
            }, 
            {
                path: "parked-carts",
                loadChildren: () => import('./pages/secure/parked-carts/parked-carts.module').then( m => m.ParkedCartsPageModule),
                canActivate: [LoggedInGuard],
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
    providers: [LoggedInGuard],
    exports: [RouterModule],
})
export class AppRoutingModule { }
